import { AccountStorageAPI } from "./AccountStorageAPI";
import { ViewLocation, isViewLocation } from "../models/AppPage";

// Legacy account-storage custom views. Read-only: views now live in each
// device's `general.appPages`, and older App builds still read these.
const APP_PAGE_KEY_PREFIX = "custom_app_page_";

const storage = new AccountStorageAPI();

// Free-form JSON, written by older builds too, so never trust its shape.
const normalize = (data, index) => ({
  ...data,
  enabled: data.enabled !== false,
  position: Number.isFinite(data.position) ? data.position : index,
  location: isViewLocation(data.location) ? data.location : ViewLocation.menu,
});

export class AppPageAPI {
  // Rejects rather than reporting an unreadable account as one with no views.
  async getAll(accountIds) {
    const ids = Array.isArray(accountIds) ? accountIds : [accountIds];
    const results = await Promise.all(
      ids.map(async (accountId) => {
        const all = await storage.getAll(accountId);
        // Read as the App does: sorted keys (stable fallback positions), and
        // unreadable entries skipped.
        return Object.keys(all || {})
          .filter((key) => key.startsWith(APP_PAGE_KEY_PREFIX))
          .sort()
          .reduce((pages, key, index) => {
            const item = all[key];
            const data = AccountStorageAPI.decodeContent(item?.content);
            if (data && typeof data === "object" && !Array.isArray(data)) {
              pages.push(
                normalize(
                  { ...data, id: key, name: item?.name ?? data.name ?? "" },
                  index
                )
              );
            }
            return pages;
          }, []);
      })
    );
    return results.flat();
  }
}
